export const getProReportBySubmissionId = async (submissionId) => {
  if (!submissionId) return null;

  const response = await fetch(
    `/api/pro-report?propertyId=${encodeURIComponent(submissionId)}`
  );
  const data = await response.json().catch(() => ({}));

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(data.detail || data.error || "No se pudo cargar el reporte Pro.");
  }

  return data.report || null;
};

export const mapProReportToAdvisor = (report) => {
  if (!report) return null;

  const directCompetitors = Array.isArray(report.direct_competitors)
    ? report.direct_competitors
    : [];
  const nearbyBusinesses = Array.isArray(report.nearby_businesses)
    ? report.nearby_businesses
    : [];

  return {
    usosSugeridos: report.recommended_businesses || [],
    usosNoRecomendados: report.not_recommended_businesses || [],
    competenciaCercana: directCompetitors
      .slice(0, 6)
      .map((place) => `${place.name}${place.distanceMeters ? ` (${place.distanceMeters} m)` : ""}`),
    generadoresDemanda: nearbyBusinesses
      .slice(0, 8)
      .map((place) => place.type || place.name)
      .filter(Boolean),
    ventajas: [report.demand_summary, report.owner_summary].filter(Boolean),
    riesgos: [report.risk_summary].filter(Boolean),
    validarAntes: [
      "Validar flujo real en horario fuerte del giro.",
      "Confirmar permisos, uso de suelo y restricciones del inmueble.",
    ],
    perfilCliente: {
      confianza: report.confidence_level || "",
      notas: [report.confidence_summary, report.seeker_summary].filter(Boolean),
    },
    reportePro: {
      score: report.score,
      generadoEn: report.generated_at,
      venceEn: report.expires_at,
      resumenCompetencia: report.competition_summary,
      resumenDemanda: report.demand_summary,
    },
  };
};
